// assets
import { IconShieldCheck } from '@tabler/icons';

// constant
const icons = {
    IconShieldCheck
};

// ==============================|| MENU ITEMS - UAFE ||============================== //

const uafe = {
    id: 'uafe',
    title: 'UAFE',
    type: 'group',
    children: [
        {
            id: 'listadoUafe',
            title: 'Módulo UAFE',
            type: 'item',
            url: '/UAFE/index',
            icon: icons.IconShieldCheck,
            breadcrumbs: true
        }
    ]
};

export default uafe;
